// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content[data-v-4adb230f]{font-family:Roboto Mono,monospace;font-size:12px;display:grid;grid-template-columns:3fr 2fr;grid-gap:16px}.content .label[data-v-4adb230f]{text-align:right}.content .value[data-v-4adb230f]{color:#42b983}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
